// extracted by mini-css-extract-plugin
module.exports = {"discoverLink":"styles_discoverLink__yokJi","discoverLink__dark":"styles_discoverLink__dark__gVeX5","discoverLink__light":"styles_discoverLink__light__WsxhU"};